import { FileType, SubmissionTask } from 'enums';

export const SubmissionTaskExpectedFileTypesConfig: Partial<Record<SubmissionTask, FileType[]>> = {
  [SubmissionTask.RenewalDocs]: [FileType.PastApplication, FileType.Supplement],
  [SubmissionTask.ExpiringPolicies]: [FileType.ExpiringProgram],
  [SubmissionTask.LossRuns]: [FileType.LossRuns],
};

export const allExpectedSubmissionFileTypes = Object.values(SubmissionTaskExpectedFileTypesConfig).flat();
